import { create } from "zustand";
import { getWSClient } from "@/lib/ws";

interface WSState {
  connected: boolean;
  reconnecting: boolean;
  sessionId: string | null;

  setConnected: (connected: boolean) => void;
  setReconnecting: (reconnecting: boolean) => void;
  setSessionId: (sessionId: string | null) => void;
  manualReconnect: () => void;
  reset: () => void;
}

const initialState = {
  connected: false,
  reconnecting: false,
  sessionId: null,
};

export const useWSStore = create<WSState>((set) => ({
  ...initialState,

  setConnected: (connected: boolean) => set({ connected }),

  setReconnecting: (reconnecting: boolean) => set({ reconnecting }),

  setSessionId: (sessionId: string | null) => set({ sessionId }),

  manualReconnect: () => {
    getWSClient().manualReconnect();
  },

  reset: () => set({ ...initialState }),
}));
